import type { ListGenerationsParams } from '@paint-ai/shared';

export type GenerationFilterParams = Omit<ListGenerationsParams, 'cursor' | 'limit'>;

/** Central TanStack Query keys, so features can invalidate each other's data without importing internals. */
export const queryKeys = {
  generations: {
    all: ['generations'] as const,
    list: (filters: GenerationFilterParams) => ['generations', 'list', filters] as const,
    stats: () => ['generations', 'stats'] as const,
  },
};
